var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3316_25400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.44409,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#38A169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9725 19.1778L27.6388 27.3591C27.405 29.2566 25.0537 29.9441 23.5 29.9441H14.8238C14.5487 29.9441 14.3012 29.8753 14.095 29.7516L12.115 28.5691H9.75C8.2925 28.5691 7 27.2766 7 25.8191V20.3191C7 18.8616 8.2925 17.5416 9.75 17.5691H12.5C13.7513 17.5691 14.4112 16.9503 15.7863 15.4378C17.0375 14.0628 16.9963 12.9628 16.6525 10.9416C16.5425 10.2541 16.735 9.56659 17.23 8.98909C17.7662 8.34284 18.5775 7.94409 19.375 7.94409C21.8912 7.94409 23.5 13.0453 23.5 14.8328L23.4725 16.1803H26.2775C27.8725 16.1803 28.9587 17.2803 29 18.8891C29 19.0403 28.9725 19.1778 28.9725 19.1778ZM26.2638 17.5416H23.5275C22.565 17.5416 22.1112 17.1566 22.1112 16.2078L22.1525 14.7916C22.1525 13.0453 20.5438 9.29159 19.4025 9.29159C18.715 9.29159 17.9175 9.97909 18.0275 10.6666C18.3713 12.8391 18.495 14.4891 16.8038 16.3591C15.4012 17.9128 14.37 18.9441 12.5 18.9441V27.1941L14.7963 28.5691H23.5C24.5037 28.5691 26.1812 28.1428 26.25 27.1941L26.2775 27.1666L27.6525 18.9166C27.6112 18.0366 27.13 17.5416 26.2775 17.5416H26.2638Z",
    fill: "#1C4532"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.44409,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#38A169"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3316_25400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.944092)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7520da402b8b14b9592fbc8fdee29071.svg";
export { ForwardRef as ReactComponent };